const SM4Util = require('./SM4Util/index.js')
const key = '304967661ab386c6'

/**
 * @param message 需要加密的信息
 * @returns 加密结果
 */
export function sm4Encode(message: string): string {
  const enCode: string = SM4Util.sm4ECBEncrypt(message, key)
  return enCode
}

/**
 * @param message 需要解密的信息
 * @returns 解密结果
 */
export function sm4Decode(message: string): string {
  const deCode = SM4Util.sm4ECBDecrypt(message, key)
  return deCode
}

/**
 * 手机号脱敏
 * @param {string} phone 手机号码
 * @returns {string} 脱敏后的手机号
 */
export function maskPhone(str: string) {
  console.log(str)
  // return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  if (str.length <= 3) return str // 不足4位直接返回
  const prefix = str.slice(0, 3) // 前3位
  const middle = '****' // 要替换的部分
  const suffix = str.slice(7) // 第8位及以后
  return prefix + middle + suffix
}
